import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=4ab1347e&scoped=true&"
import script from "./ModalHeader.vue?vue&type=script&lang=js&"
export * from "./ModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=4ab1347e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab1347e",
  null
  
)

export default component.exports